import React from 'react';
import { AidFrontendFeatureGate } from '../providers/FeatureGates';
import { checkFeatureGate } from '../utilities/feature-flags/feature-gate';

// HARDCODED FOR TESTING PURPOSES
const AWS_CAPTCHA_TESTING_URL =
  'https://1828c3f6dfd3.edge.captcha-sdk.awswaf.com/1828c3f6dfd3/jsapi.js';
const AWS_CAPTCHA_TESTING_API_KEY =
  'fUYaStK10qDtzaf48k7ulR0UOwifvafIVQFdZj/LArV8jPl/4B127LFuLZgnbZpu2kQjYY0kQwkvqCBqqxNKbPSEcj99w7rJoAppHwRyGP4znqP0Pm5HlFhSzCG0HtdwrAKcCXOpBKR3/evdkrD5E9jvVi+aSwwanlu1wdpG/tEnR4KfdksD7MmfZyO7g6f5b1/NX45MeHDFdIq9H2tGYBBLe3vYGqy1XKmH4HXrZYxZOSPWBft73Tqz/RuzSOu3HDDTdP+Rci1YFGatemiToh3L7bjS7alSg65C1agF0JADfzNVGXhLEok5p6pJDVy1lNkirwVpK5iHRV34Yrf/HoBiEV1VCA7ncq9/xqXEs8bYgjckUwb3mmk3PvzDSH1qq/63+/r9CT689Yl8NXpalqWGl81UKNeHk9Dqpvg9JtXyTsSgrv4mPd2dNjGaWTkql9S8E22MNpOKy+Lq4Q+x1EpoQoer6ktFf8pB9rtBKv71yJj7Dcjq5BCYdvu8e78HZdrfWROUmDdEKPY5pbQ5DrOR8EVMze4IhdvmCBeWpJIbepXFmgronWlUadeSPmoLb6d0a+fQPHOCH8pyQZxpgTHn2RlPpLNTIAYF+Gv7pdxiv0fF96TDmFEUZTal8ZbPMdieWYq8ZgzhmJ2Fmn90Vew1Fw71sekhAMxGJiXVX1s=_1_1';

const AWS_CAPTCHA_SCRIPT_ID = 'aws-captcha-jsapi';

type AwsWafCaptcha = {
  renderCaptcha: (
    container: HTMLElement,
    options: {
      apiKey: string;
      onSuccess: (wafToken: string) => void;
      onError: (error: unknown) => void;
    }
  ) => void;
};

export const isAwsCaptchaTestingEnabled = () =>
  checkFeatureGate(AidFrontendFeatureGate.ENABLE_AWS_WAF_CAPTCHA);

export const injectAwsCaptchaScript = () => {
  if (document.getElementById(AWS_CAPTCHA_SCRIPT_ID)) {
    return;
  }

  const scriptElement = document.createElement('script');
  scriptElement.id = AWS_CAPTCHA_SCRIPT_ID;
  scriptElement.src = AWS_CAPTCHA_TESTING_URL;
  scriptElement.defer = true;

  document.head.appendChild(scriptElement);
};

export const renderAwsCaptchaPuzzle = ({
  onSuccess,
  onError,
}: {
  onSuccess: (wafToken: string) => void;
  onError: (error: unknown) => void;
}) => {
  const container = document.getElementById('my-captcha-container');

  if (!container) return;

  const awsWafCaptcha = (window as Window & { AwsWafCaptcha?: AwsWafCaptcha }).AwsWafCaptcha;

  awsWafCaptcha?.renderCaptcha(container, {
    apiKey: AWS_CAPTCHA_TESTING_API_KEY,
    onSuccess,
    onError,
  });
};

export const AWSWafCaptchaComponent = () => {
  return (
    <div>
      {/* modal */}
      <div id="my-captcha-container" />
      {/* <button onClick={() => showMyCaptcha({ onSuccess: captchaExampleSuccessFunction, onError: captchaExampleErrorFunction })}>Show Captcha</button> */}
    </div>
  );
};
